import { Field, NumericInput, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent, WorksheetAssociatedTestSection } from 'Components/Worksheets/Core';
import { AssociatedTestType } from 'Components/Worksheets/Core/WorksheetAssociatedTestSection/types';
import ExternalTestMethods from 'Components/Worksheets/ExternalTestMethods';
import { Guid } from 'Lib/Guid';
import { useSelector } from 'react-redux';

export interface IWholePortionAssociatedMoistureContentSection extends IWorksheetComponent {
  /**
   * Heading for the moisture content assoicated test section.
   *
   * e.g. "As Received Water Content"
   */
  heading: string;
}

const WholePortionAssociatedMoistureContentSectionBase: React.FC<IWholePortionAssociatedMoistureContentSection> = ({
  createWorksheetSelector,
  heading,
}) => {
  const importedMoistureContentId: Guid = useSelector(
    createWorksheetSelector!('AssociatedMoistureContent.ImportedTest.Id')
  );
  return (
    <WorksheetAssociatedTestSection
      name="AssociatedMoistureContent"
      heading={heading}
      label={`${heading} Determined By`}
      testType="Moisture Content"
      defaultSelection={AssociatedTestType.AutoImported}
      associatedTestModel={{
        measured: true,
        autoImported: true,
        imported: {
          importedTestResults: (
            <ListFieldSection>
              <Field input={<TextOutput />} name="MoistureContent" emph />
            </ListFieldSection>
          ),
          importModel: {
            Id: importedMoistureContentId,
          },
        },
        external: {
          testMethods: [
            ExternalTestMethods.moistureContent.BS_EN_ISO_17892_1,
            ExternalTestMethods.moistureContent.ISO_17892_1,
          ],
          externalTestResults: (
            <ListFieldSection>
              <Field
                input={<NumericInput />}
                name="AssociatedMoistureContent.ExternalTest.Results.MoistureContentPercent"
              />
            </ListFieldSection>
          ),
        },
      }}
    />
  );
};

const WholePortionAssociatedMoistureContentSection = withInjectedProps(
  WholePortionAssociatedMoistureContentSectionBase
);

export { WholePortionAssociatedMoistureContentSection };
export default WholePortionAssociatedMoistureContentSection;
